function SubjectArchive(el) {
    this.el = el;
    // this.resetBtnEl = this.el.querySelector('.jsSubjectArchiveResetBtn');
    this.letterWrapperEl = this.el.querySelector('.jsSubjectArchiveLetters');
    this.subjectWrapperEl = this.el.querySelector('.jsSubjectArchiveSubjects');
    this.letters = this.letterWrapperEl.querySelectorAll('button');
    this.subjects = this.subjectWrapperEl.querySelectorAll('.jsSubjectArchiveSubject');
    this.letterLists = this.subjectWrapperEl.querySelectorAll('.jsSubjectArchiveLetterList');
    this.imgEl = this.el.querySelector('.jsSubjectArchiveImg');
    this.imgLetterEl = this.imgEl.querySelector('span');
    this.searchInput = this.el.querySelector('.jsSearchInput');

    this.letterWrapperEl.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'button') this.activateLetter(e.target.dataset.letter, false);
    });

    this.searchInput.addEventListener('keyup', e => {
        this.search(this.searchInput.value);
    });

    this.activateFirstLetter();
}

SubjectArchive.prototype.activateFirstLetter = function() {
    // Activate the first available letter, if any
    const firstEnabledLetter = this.letterWrapperEl.querySelector('button:not(:disabled)');
    if (firstEnabledLetter) this.activateLetter(firstEnabledLetter.dataset.letter, true);
};

SubjectArchive.prototype.activateLetter = function(letter) {
    this.subjectWrapperEl.classList.remove('search');

    this.imgLetterEl.innerHTML = letter;
    this.searchInput.value = '';

    // Activate the letter trigger
    for (let i = 0; i < this.letters.length; i++) {
        if (this.letters[i].dataset.letter === letter) this.letters[i].classList.add('active');
        else this.letters[i].classList.remove('active');
    }

    // Show the correct letter list
    for (let i = 0; i < this.letterLists.length; i++) {
        if (this.letterLists[i].dataset.letter === letter) this.letterLists[i].classList.remove('hidden');
        else this.letterLists[i].classList.add('hidden');
    }
};

SubjectArchive.prototype.search = function(query) {
    this.reset();

    query = query.toLowerCase();

    if (query !== '') {
        this.subjectWrapperEl.classList.add('search');

        for (let i = 0; i < this.subjects.length; i++) {
            if (this.subjects[i].dataset.title.toLowerCase().indexOf(query) === -1) {
                this.subjects[i].classList.add('hidden');
            }
        }
    }

    // Hide all letter lists that don't have any active subjects and show all others
    for (let i = 0; i < this.letterLists.length; i++) {
        const activeSubjects = this.letterLists[i].querySelectorAll('.jsSubjectArchiveSubject:not(.hidden)');
        if (activeSubjects.length === 0) this.letterLists[i].classList.add('hidden');
        else this.letterLists[i].classList.remove('hidden');
    }
};

SubjectArchive.prototype.reset = function() {
    this.imgLetterEl.innerHTML = '';
    this.subjectWrapperEl.classList.add('search');

    for (let i = 0; i < this.letters.length; i++) this.letters[i].classList.remove('active');
    for (let i = 0; i < this.subjects.length; i++) this.subjects[i].classList.remove('hidden');
};

(function() {
    const subjectArchiveEl = document.querySelector('.jsSubjectArchive');
    if (subjectArchiveEl) new SubjectArchive(subjectArchiveEl);
})();
